// extracted by mini-css-extract-plugin
export default {"StatusIconVerified":"StatusIcon_StatusIconVerified__pdJdV","StatusIconWaiting":"StatusIcon_StatusIconWaiting__R09ga","StatusIconNoStatus":"StatusIcon_StatusIconNoStatus__vJHqc"};